import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const usePostQuery = createQueryHook(MembershipsCreatorApiClient.getPost, {
  queryKey: ['post'],
})
